import React, { FC, ReactNode, useLayoutEffect } from "react";
import { defineMessages, useIntl } from "react-intl";
import { useLocation, useNavigate } from "react-router-dom";
import { GradientWrapper, ThankYouCard } from "@app/components";
import { useSetUserLanguage } from "@app/hooks";
import { Language } from "@app/provider";
import { routes } from "@app/routing";
import { isValidLanguageValue, useQuery } from "@app/utils";
import "./renewalInterested.scss";

const messages = defineMessages({
  renewalInterestedThankYouTitle: {
    id: "renewalInterestedThankYouTitle",
    defaultMessage: "Thank you!",
  },
  renewalInterestedResponseRecorded: {
    id: "renewalInterestedResponseRecorded",
    defaultMessage:
      "We have recorded your response. Natera’s team will work with your healthcare provider(s) to ensure you do not have any gaps in testing.",
  },
  renewalInterestedPortalLink: {
    id: "renewalInterestedPortalLink",
    defaultMessage:
      "You can track your test statuses, pay your bill, schedule appointments, and access educational material in {link}.",
  },
  renewalInterestedPortalLinkText: {
    id: "renewalInterestedPortalLinkText",
    defaultMessage: "your patient portal account",
  },
});

const RenewalInterested: FC<{ children?: ReactNode }> = () => {
  const intl = useIntl();
  const query = useQuery();
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const lang = query.get("lang");
  const setUserLanguage = useSetUserLanguage();

  useLayoutEffect(() => {
    if (lang && isValidLanguageValue(lang)) {
      setUserLanguage(lang as Language);
      navigate({ pathname }, { replace: true });
    }
  }, []);

  const message = (
    <div className="renewal-interested__message">
      <p>{intl.formatMessage(messages.renewalInterestedResponseRecorded)}</p>
      <p>
        {intl.formatMessage(messages.renewalInterestedPortalLink, {
          link: (
            <a className="renewal-interested-portal-link" href={routes.logIn}>
              {intl.formatMessage(messages.renewalInterestedPortalLinkText)}
            </a>
          ),
        })}
      </p>
    </div>
  );

  return (
    <GradientWrapper display className="renewal-interested">
      <div className="renewal-interested__container">
        <ThankYouCard
          title={intl.formatMessage(messages.renewalInterestedThankYouTitle)}
          message={message}
        />
      </div>
    </GradientWrapper>
  );
};

export default RenewalInterested;
